import { MeetingAttendeeTableService } from './meeting-attendees/meeting-attendee-table.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from '@morningstar/shared/ui-kit/angular-material';
import { MeetingAttendeeCheckInComponent } from './meeting-attendee-check-in/meeting-attendee-check-in.component';
import { MeetingAttendeesService } from './meeting-attendee.service';
import { HeadingModule } from '@morningstar/shared/ui-kit/heading';
import { MeetingAttendeeRegisterComponent } from './meeting-attendee-register/meeting-attendee-register.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MeetingCodeValidationComponent } from './meeting-code-validation/meeting-code-validation.component';
import { MeetingCheckInHomeComponent } from './meeting-check-in-home/meeting-check-in-home.component';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromMeetingAttendees from './+state/meeting-attendees/meeting-attendees.reducer';
import { MeetingAttendeesEffects } from './+state/meeting-attendees/meeting-attendees.effects';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MeetingAttendeesComponent } from './meeting-attendees/meeting-attendees.component';

@NgModule({
  imports: [
    CommonModule,
    AngularMaterialModule,
    HeadingModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    RouterModule,
    StoreModule.forFeature(
      fromMeetingAttendees.MEETINGATTENDEES_FEATURE_KEY,
      fromMeetingAttendees.reducer
    ),
    EffectsModule.forFeature([MeetingAttendeesEffects])
  ],
  declarations: [
    MeetingAttendeeCheckInComponent,
    MeetingAttendeeRegisterComponent,
    MeetingCodeValidationComponent,
    MeetingCheckInHomeComponent,
    MeetingAttendeesComponent
  ],
  exports: [
    MeetingAttendeeCheckInComponent,
    MeetingAttendeeRegisterComponent,
    MeetingCodeValidationComponent,
    MeetingCheckInHomeComponent,
    MeetingAttendeesComponent
  ],
  providers: [
    MeetingAttendeesService,
    MeetingAttendeeTableService
  ]
})
export class SharedMeetingAttendeesModule {}
